import React from 'react'
import { css } from '@emotion/css'
import { AssessGradeBadgeWithTooltip } from '../../components/badge'
import { CellRenderer } from '../../legacy-design-system/grid'
import { Application } from './shared'
import { AgentFeature, isFeatureEnabledForLanguage } from '../agent-features'
import { mapScoresLetterGrade } from '../../graphql/schema/queries/helpers/application'

const gradeCellCss = css`
  padding: 0 2px;
`

interface GetRendererProps {
  readonly features?: AgentFeature[]
}

export function getGradeCellRenderer({
  features
}: GetRendererProps): CellRenderer<Application> {
  return function gradeCellRenderer({
    rowData: { language, scoreGrade },
    getCellContentProps
  }) {
    const isAssessSupported =
      features &&
      isFeatureEnabledForLanguage({
        language,
        agentFeatures: features,
        featureName: 'assess'
      })

    return (
      <div
        {...getCellContentProps({
          className: gradeCellCss
        })}
      >
        <AssessGradeBadgeWithTooltip
          value={mapScoresLetterGrade(scoreGrade)}
          isAssessSupported={isAssessSupported}
        />
      </div>
    )
  }
}

export function loadingGradeCellRenderer() {
  return (
    <div className={gradeCellCss}>
      <AssessGradeBadgeWithTooltip value="UNKNOWN" />
    </div>
  )
}
